import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { Element } from '../element';
import { Icon } from '../icon';
import * as styles from './alert.styles';

/** @type {typeof import(".").Alert} */
const Alert = forwardRef(({ layout = 'horizontal', variant, title, icon, onClose, className, children, ...props }, ref) => {
  return (
    <Element as="div" ref={ref} className={clsx(styles.alert, className, { [styles.variants[variant]]: variant })} {...props}>
      <Element as="div" className={clsx(styles.components.container, { [styles.variants[layout]]: layout })}>
        <Element className={styles.components.title}>
          {icon && <Icon className={styles.components.icon} name={icon} />} {title}
        </Element>
        <Element as="div" className={styles.components.content}>
          {children}
        </Element>
      </Element>
      {onClose && <Icon name="cross" isInteractive role="button" tabIndex={0} className={styles.components.btnClose} onClick={onClose} />}
    </Element>
  );
});

if (process.env.NODE_ENV !== 'production') {
  Alert.displayName = 'Alert';
}

export default Alert;
